import { render, staticRenderFns } from "./tileTabs.vue?vue&type=template&id=0428308b&scoped=true&"
import script from "./tileTabs.vue?vue&type=script&lang=js&"
export * from "./tileTabs.vue?vue&type=script&lang=js&"
import style0 from "./tileTabs.vue?vue&type=style&index=0&id=0428308b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428308b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0428308b')) {
      api.createRecord('0428308b', component.options)
    } else {
      api.reload('0428308b', component.options)
    }
    module.hot.accept("./tileTabs.vue?vue&type=template&id=0428308b&scoped=true&", function () {
      api.rerender('0428308b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/tileTabs/tileTabs.vue"
export default component.exports